import fp from 'lodash/fp'
import { combine, withCallback } from 'react-hooks-combine'

import ToggleComponent from './component'

export default combine(
  withCallback(
    'onInternalChange',
    (_, { onChange }) =>
      (value) => {
        onChange({
          target: {
            value: fp.get('target.checked', value),
          },
        })
      },
    []
  )
)(ToggleComponent)
